import { inject, Injectable, signal } from '@angular/core';
import { SocketService } from '@core/services/socket.service';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceService {
  private readonly socketService = inject(SocketService);

  maintenanceMessage = signal<string | null>(null);

  constructor() {
    this.socketService.socket.on(
      'maintenance_message',
      (data: { message: string }) => {
        this.maintenanceMessage.set(data.message);
      }
    );
  }
}
